
export default sortable => {
    return {
        name: (a, b) => a.name > b.name ? 1 : -1,
        volume: (a, b) => a.volume - b.volume,
        price: (a, b) => b.price - a.price,
    }[sortable];
}
